import * as RadixTooltip from "@radix-ui/react-tooltip";
import { css } from "@pigment-css/react";
import { Chip } from "../Chip";

interface PercentageChipProps {
  value: number;
  size?: "small" | "large";
  tooltip?: string;
}

const MAX_DISPLAY = 999;

const tooltipContent = css(({ theme }) => ({
  color: theme.managementView.colors.neutral[90],
  fontFamily: theme.managementView.font.familySecondary,
  backgroundColor: theme.managementView.colors.neutral[0],
  padding: `${theme.managementView.spacing[8]} ${theme.managementView.spacing[12]}`,
  borderRadius: theme.managementView.radius[16],
  border: `1px solid ${theme.managementView.colors.neutral[8]}`,
  fontSize: theme.managementView.font.size[13],
  fontWeight: theme.managementView.font.weight[400],
  zIndex: 10010,
}));

export const formatPercentageChange = (value: number) => {
  const isPositive = value >= 0;
  const capped = Math.abs(value) > MAX_DISPLAY;
  const text = capped ? `${isPositive ? ">" : "<-"}${MAX_DISPLAY}%` : `${isPositive ? "+" : ""}${Math.round(value)}%`;
  return { text, isPositive };
};

export const PercentageChip = ({ value, size = "large", tooltip }: PercentageChipProps) => {
  const { text, isPositive } = formatPercentageChange(value);

  const chip = (
    <Chip size={size} color={isPositive ? "success" : "error"}>
      {text}
    </Chip>
  );

  if (!tooltip) return chip;

  return (
    <RadixTooltip.Root>
      <RadixTooltip.Trigger asChild>{chip}</RadixTooltip.Trigger>
      <RadixTooltip.Portal>
        <RadixTooltip.Content className={tooltipContent} side="bottom" sideOffset={4}>
          {tooltip}
        </RadixTooltip.Content>
      </RadixTooltip.Portal>
    </RadixTooltip.Root>
  );
};
